export const lightBulb = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
  >
    <path
      d="M16 17C16 15.8 17 14.8809 17.899 14C19.1955 12.7295 20 10.9587 20 9C20 5.13401 16.866 2 13 2C9.13401 2 6 5.13401 6 9C6 10.9587 6.80447 12.7295 8.10102 14C9.12151 15 10 15.8 10 17"
      stroke="#1350E8"
      strokeWidth="2"
    />
    <path
      d="M16 20C16 21.6569 14.6569 23 13 23C11.3431 23 10 21.6569 10 20"
      stroke="#1350E8"
      strokeWidth="2"
    />
    <rect x="10" y="17" width="6" height="3" stroke="#1350E8" strokeWidth="2" />
    <path
      d="M16 9C16 7.34315 14.6569 6 13 6"
      stroke="#1350E8"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const magnifyingGlass = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
  >
    <circle cx="11" cy="11" r="5" stroke="#85979E" strokeWidth="2" />
    <path
      d="M14 15L19 20"
      stroke="#85979E"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const notificationBell = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
  >
    <path
      d="M16 17V18C16 19.6571 14.6566 20.9995 13 21C11.3434 21 10 19.6571 10 18V17"
      stroke="#85979E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0002 6C10.0263 6 7.61556 8.46243 7.61556 11.5V13.7C7.61556 14.3351 7.4 15.9 6.53846 15.9C6.35897 15.9 6 16.01 6 16.45C6 16.89 6.35897 17 6.53846 17H19.4615C19.4615 17 20 16.89 20 16.45C20 16.01 19.641 15.9 19.4615 15.9C18.6 15.9 18.3848 14.3351 18.3848 13.7V11.5C18.3848 8.46243 15.974 6 13.0002 6Z"
      stroke="#85979E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle
      cx="19"
      cy="6"
      r="4"
      fill="#1350E8"
      stroke="#E4EBEB"
      strokeWidth="2"
    />
  </svg>
);

export const star = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
  >
    <path
      d="M12.0489 4.92705C12.3483 4.00574 13.6517 4.00574 13.9511 4.92705L15.2451 8.90983C15.379 9.32185 15.763 9.60081 16.1962 9.60081H20.3839C21.3527 9.60081 21.7554 10.8404 20.9717 11.4098L17.5838 13.8713C17.2333 14.126 17.0866 14.5773 17.2205 14.9894L18.5146 18.9721C18.8139 19.8934 17.7595 20.6596 16.9757 20.0902L13.5878 17.6287C13.2373 17.374 12.7627 17.374 12.4122 17.6287L9.02426 20.0902C8.24054 20.6596 7.18607 19.8934 7.48542 18.9721L8.7795 14.9894C8.91338 14.5773 8.76672 14.126 8.41623 13.8713L5.02827 11.4098C4.24456 10.8404 4.64734 9.60081 5.61606 9.60081H9.8038C10.237 9.60081 10.621 9.32185 10.7549 8.90983L12.0489 4.92705Z"
      stroke="#85979E"
      strokeWidth="2"
    />
  </svg>
);

export const userAvatar = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
  >
    <circle cx="13" cy="8" r="3" stroke="white" strokeWidth="2" />
    <path
      d="M13 14C9.68629 14 7 16.6392 7 19.8947V20C7 20.5523 7.44772 21 8 21H18C18.5523 21 19 20.5523 19 20V19.8947C19 16.6392 16.3137 14 13 14Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const circleWithArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
  >
    <path
      d="M11.5 17L15.5 13L11.5 9"
      stroke="#1350E8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const thickCross = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M10.1923 0.292947L7.28071 3.20456C6.89019 3.59509 6.25702 3.59509 5.8665 3.20456L2.95488 0.292948C2.56436 -0.0975763 1.9312 -0.097577 1.54067 0.292947L0.292835 1.54078C-0.0976894 1.93131 -0.0976896 2.56447 0.292835 2.955L3.20445 5.86661C3.59498 6.25714 3.59498 6.8903 3.20445 7.28083L0.292837 10.1924C-0.097688 10.583 -0.0976883 11.2161 0.292836 11.6067L1.54067 12.8545C1.9312 13.245 2.56436 13.245 2.95489 12.8545L5.8665 9.94288C6.25702 9.55235 6.89019 9.55235 7.28071 9.94288L10.1923 12.8545C10.5829 13.245 11.216 13.245 11.6065 12.8545L12.8544 11.6067C13.2449 11.2161 13.2449 10.583 12.8544 10.1924L9.94276 7.28083C9.55224 6.8903 9.55224 6.25714 9.94276 5.86661L12.8544 2.955C13.2449 2.56447 13.2449 1.93131 12.8544 1.54078L11.6065 0.292946C11.216 -0.097578 10.5829 -0.0975776 10.1923 0.292947Z"
      fill="white"
    />
  </svg>
);

export const cross = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="white"
  >
    <path d="m4.12 6.137 1.521-1.52 7 7-1.52 1.52z" />
    <path d="m4.12 11.61 7.001-7 1.52 1.52-7 7z" />
  </svg>


);

export const play = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
  >
    <path
      d="M13.4686 3.81129C15.2721 4.42827 15.2721 6.97895 13.4686 7.59594L2.64737 11.2979C1.34948 11.742 -5.05904e-07 10.7774 -4.45943e-07 9.4056L-1.22305e-07 2.00162C-6.23439e-08 0.629875 1.34948 -0.334724 2.64738 0.109294L13.4686 3.81129Z"
      fill="white"
    />
  </svg>
);

export const pause = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 26 26"
    fill="none"
  >
    <rect x="9" y="8" width="2" height="10" rx="1" fill="white" />
    <rect x="15" y="8" width="2" height="10" rx="1" fill="white" />
  </svg>
);

export const check = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="9"
    viewBox="0 0 14 9"
    fill="none"
  >
    <path
      d="M13 1L6.16589 7.3785C5.78851 7.73073 5.20504 7.73781 4.81921 7.39485L1 4"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const hamburger = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
  >
    <rect x="5" y="8" width="16" height="2" rx="1" fill="#85979E" />
    <rect x="5" y="12" width="16" height="2" rx="1" fill="#85979E" />
    <rect x="5" y="16" width="10" height="2" rx="1" fill="#85979E" />
  </svg>
);

export const ratingStar = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    aria-hidden="true"
  >
    <path d="M18.2065 3.63397C18.9402 2.14748 21.0598 2.14748 21.7935 3.63397L25.4125 10.9669C25.7038 11.5572 26.267 11.9664 26.9184 12.061L35.0108 13.2369C36.6512 13.4753 37.3063 15.4912 36.1192 16.6483L30.2635 22.3562C29.7921 22.8157 29.577 23.4777 29.6883 24.1265L31.0707 32.1862C31.3509 33.82 29.636 35.066 28.1688 34.2946L20.9307 30.4893C20.348 30.183 19.652 30.183 19.0693 30.4893L11.8312 34.2946C10.364 35.066 8.64912 33.82 8.92934 32.1862L10.3117 24.1265C10.423 23.4777 10.2079 22.8157 9.7365 22.3562L3.88077 16.6483C2.69373 15.4912 3.34876 13.4753 4.9892 13.2369L13.0816 12.061C13.733 11.9664 14.2962 11.5572 14.5875 10.9669L18.2065 3.63397Z" />
  </svg>
);

export const info = (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="26" height="26" rx="4" fill="#1350E8" />

    <g transform="translate(11.5 7)">
      <path d="M0.463971 7.32795L0.0159707 -4.95911e-05H2.63997L2.19197 7.32795H0.463971ZM-2.92063e-05 9.98395C-2.92063e-05 9.23195 0.607971 8.63995 1.32797 8.63995C2.04797 8.63995 2.65597 9.23195 2.65597 9.98395C2.65597 10.704 2.07997 11.296 1.32797 11.296C0.575971 11.296 -2.92063e-05 10.704 -2.92063e-05 9.98395Z" fill="white" />
    </g>
  </svg>

)

export const plus = (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path d="M13 8V18" stroke="#1350E8" stroke-width="2" stroke-linecap="round" />
    <path d="M18.0049 12.9951L8.00488 12.9951" stroke="#1350E8" stroke-width="2" stroke-linecap="round" />
  </svg>

)

export const minus = (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path d="M18.0049 12.9951L8.00488 12.9951" stroke="#1350E8" stroke-width="2" stroke-linecap="round" />
  </svg>
)